<template>
  <el-row :gutter="10">
    <el-col :span="24">
      <div class="side-frame">
        <span style="font-size: 15px; color: #606266">
          {{ $l('INDEX.booking_container_title') || '装柜PO' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-dropdown @command="handleCommand">
          <el-button type="primary" size="mini">
            选择批量更新字段<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="bookingNo">FCR NO.</el-dropdown-item>
            <el-dropdown-item command="customsNo">关单号</el-dropdown-item>
            <el-dropdown-item command="bookingNumber">订舱单号</el-dropdown-item>
            <el-dropdown-item
              v-if="shipmentStatus === 'S' || shipmentStatus === 'M'"
              command="consignee"
              >收货人</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    shipmentStatus: { type: String, default: '' },
  },
  methods: {
    handleCommand(e) {
      this.$emit('openDialog', e)
    },
  },
}
</script>
